import { apiClient } from "@/shared/lib/api-client";
import type { MeResponse, ChangePasswordRequest } from "../types";

/**
 * Fetches the current authenticated user's profile.
 * GET /v1/users/me
 *
 * @returns The current user's profile data
 * @throws {ApiError} On request failure (e.g. 401 Unauthorized)
 */
export async function fetchMe(): Promise<MeResponse> {
  return apiClient.get<MeResponse>("/v1/users/me");
}

/**
 * Logs out the current user by invalidating the session/refresh token cookie.
 * POST /v1/users/logout
 *
 * @throws {ApiError} On request failure
 */
export async function submitLogout(): Promise<undefined> {
  return apiClient.post<undefined>("/v1/users/logout");
}

/**
 * Changes the current user's password.
 * POST /v1/users/change-password
 *
 * @param data - Change password request (currentPassword, newPassword, confirmPassword)
 * @throws {ApiError} On request failure (e.g. wrong current password)
 */
export async function submitChangePassword(data: ChangePasswordRequest): Promise<undefined> {
  return apiClient.post<undefined>("/v1/users/change-password", data);
}
